import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { FieldGroup } from '../../helpers/BootstrapHelpers';
import authService from '../../services/AuthService';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import queryString from 'query-string';

import './Login.css';

import cadeLogo from '../../content/CADEAISM.png';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';
import { alertPopup, apiErrorPopup } from '../../helpers/MessagePopup';

/*
 * Password Reset page gets invoked from an email link sent to the user.  The url has two encoded parameters: ?uid=<urlencoded(encrypted user id)&expires=urlencodedDate
 * If the user gets to this page successfully, it's job is to then gather the new password information, submit a reset request and redirect to login.
 */

export class PasswordReset extends Component {

    constructor(props) {
        super(props);

        this.state = {
            password: null,
            confirm: null,
            redirect: false
        }

        authService.clearAuthenticated();
    }

    passwordChangeHandler = (e) => {
        this.setState({ password: e.target.value });
    }

    confirmChangeHandler = (e) => {
        this.setState({ confirm: e.target.value });
    }

    submitHandler = () => {
        if (this.state.password != this.state.confirm) {
            alertPopup('warning', "The confirmation of your new password does not match.  Please re-enter both values and try again.");
            return;
        }
        if (isNullOrEmpty(this.state.password) || this.state.password.length < 8) {
            alertPopup('warning', "Your password must be a minimum of 8 characters and it must contain at least one number and one special character");
            return;
        }

        let params = queryString.parse(this.props.location.search);
        api.post("account/pwreset", {
            EncryptedUserId: params.uid,
            EncryptedExpires: params.expires,
            NewPassword: this.state.password
        })
        .then(response => {
            if (response.status == 200) {

                // Notify the user their pw was changed and redirect
                alertPopup('success', "Your password was successfully changed.  You will be redirected to the login page so that you can sign-in.");
                this.setState({ redirect: true });
            }
            else {
                // Hmmm, not a error (not found) so something else...
                alertPopup('warning', "Password reset failed: " + apiResponseHandler(response));
            }
        })
        .catch(error => {
            apiErrorPopup("Password reset failed: " + apiErrorHandler(error));
        });
    }
   
    render() {

        // Redirect if requested; otherwise, display the page.
        if (this.state.redirect) {
            return <Redirect to="/" />
        }

        // Get the new password and confirmation
        return (
            <form>
                <div >
                    <img className='loginLogo' src={cadeLogo} alt='CADE Logo' />
                </div>
                <Card className='login-panel'>
                    <Card.Body>
                        <FieldGroup
                            id="password"
                            type="password"
                            label="Password"
                            onChange = {this.passwordChangeHandler}
                            placeholder="New password"
                        />
                        <p className="login_pwInstructions">(Minimum of 8 characters and at least one number and one special character)</p>
                        <FieldGroup
                            id="confirm"
                            type="password"
                            label="Confirm Password"
                            onChange={this.confirmChangeHandler}
                            placeholder="Re-type your password"
                        />

                        <Button onClick={this.submitHandler} >Submit</Button>
                    </Card.Body>
                </Card>
                
            </form>
        )
    }
}

export default PasswordReset;




// WEBPACK FOOTER //
// ./src/components/Login/PasswordReset.js